import axios from "axios";
// 本地存储的数据
export const setUser = (data) => {
  localStorage.setItem("user", JSON.stringify(data));
};
export const getUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
export const clearUser = () => {
  localStorage.removeItem("user");
};
// 存储视频-------
export const setVideoForm = (data) => {
  localStorage.setItem("videoForm", JSON.stringify(data));
};
export const getVideoForm = () => {
  return JSON.parse(localStorage.getItem("videoForm"));
};
export const clearVideoForm = () => {
  localStorage.removeItem("videoForm");
};
// 存储文章---
export const setArticleForm = (data) => {
  localStorage.setItem("articleForm", JSON.stringify(data));
};
export const getArticleForm = () => {
  return JSON.parse(localStorage.getItem("articleForm"));
};
export const clearArticleForm = () => {
  localStorage.removeItem("articleForm");
};
export const getStream = async (url, param = {}, header = {}) => {
  try {
    const response = await axios({
      url: `${url}`,
      method: "get",
      params: param,
      requestId: url,
      timeout: 30000,
      responseType: "blob",
      headers: header,
    });
    return response.data;
  } catch (err) {
    return {
      isError: true,
      statusCode: -10001,
      message: "接口异常",
      data: null,
    };
  }
};
